import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const TrainingReactSelect = ({
  trainingDataList,
  isLoadingSelect,
  handleChange,
  disable,
}) => {
  const inProgressTraining = trainingDataList.filter(
    (training) => training?.trainingStatus === "inProgress"
  );
  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      isLoading={isLoadingSelect}
      onChange={handleChange}
      options={inProgressTraining}
      getOptionLabel={(option) => option?.trainingTitle}
      getOptionValue={(option) => option?.id}
      isDisabled={disable}
      className="focus:!border-black focus:!border-2 focus:!border-t-0"
    />
  );
};

export default TrainingReactSelect;
